import { TradierSymbolParser } from '../tradier-symbol/TradierSymbolParser';

const symbolIsSPX = (symbol?: string): boolean => {
  if (!symbol) {
    return false;
  }

  const underlyingSymbol = new TradierSymbolParser(symbol)?.underlyingSymbol;

  return (
    underlyingSymbol === 'SPX' ||
    underlyingSymbol === 'SPXW' ||
    underlyingSymbol === 'I:SPX' ||
    underlyingSymbol === '^GSPC' ||
    underlyingSymbol === '^SPX'
  );
};

export default symbolIsSPX;
